import React from "react";


import {
    Row, Col
} from "react-bootstrap";


import {
    SvgIconComponent
} from "@Components/Elements";


import {
    ButtonComponent
} from "@Components/Forms";


import IconRefreshSmWhite from "./@Icons/icon-refresh-sm-white.svg";

import IconCloud from "./@Icons/Cards/icon-cloud-sm-orange.svg";
import IconFiles from "./@Icons/Cards/icon-files-sm-orange.svg";
import IconFolder from "./@Icons/Cards/icon-folder-sm-orange.svg";
import IconStorage from "./@Icons/Cards/icon-storage-sm-orange.svg";


export const UserDashboardHomePageComponent:React.FC = () => {

    return (
        <Col xs={12} className={`user-dashboard-content-container`}>
            <Row className={`user-dashboard-content-container__container-content`}>

                <Col xs={12} className={`user-dashboard-content-header`}>
                    <Row className={`user-dashboard-content-header__header-content`}>
                        <Col xs={'auto'} className={`user-dashboard-content-header__header-content__header-title`}>
                            <span>Refund dashboard</span>
                        </Col>
                        <Col xs={'auto'} className={`user-dashboard-content-header__header-content__header-button`}>
                            <ButtonComponent
                                size={'l'} type={'cta'}
                                href={'submit-request'}
                                text={'Request a refund'} iconLeft={IconRefreshSmWhite}
                            />
                        </Col>
                    </Row>
                </Col>

                <Col xs={12} className={`user-dashboard-content-section user-dashboard-content-section--documents-summary-section`}>
                    <Row className={`user-dashboard-content-section__section-container user-dashboard-content-section--documents-summary-section__section-container`}>
                        <Col xs={6} lg={3} className={'user-dashboard-content-card'}>
                            <Row className={'user-dashboard-content-card__card-content'}>
                                <Col xs={12} className={'user-dashboard-content-card__card-header'}>
                                    <SvgIconComponent iconSource={IconCloud} className={'user-dashboard-content-card__card-header__header-icon'} />
                                    <span className={'user-dashboard-content-card__card-header__header-title'}>Total Documents</span>
                                </Col>
                                <Col xs={12} className={'user-dashboard-content-card__card-description'}>
                                    <span>0</span>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={6} lg={3} className={'user-dashboard-content-card'}>
                            <Row className={'user-dashboard-content-card__card-content'}>
                                <Col xs={12} className={'user-dashboard-content-card__card-header'}>
                                    <SvgIconComponent iconSource={IconFiles} className={'user-dashboard-content-card__card-header__header-icon'} />
                                    <span className={'user-dashboard-content-card__card-header__header-title'}>This Month</span>
                                </Col>
                                <Col xs={12} className={'user-dashboard-content-card__card-description'}>
                                    <span>0</span>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={6} lg={3} className={'user-dashboard-content-card'}>
                            <Row className={'user-dashboard-content-card__card-content'}>
                                <Col xs={12} className={'user-dashboard-content-card__card-header'}>
                                    <SvgIconComponent iconSource={IconFolder} className={'user-dashboard-content-card__card-header__header-icon'} />
                                    <span className={'user-dashboard-content-card__card-header__header-title'}>Categories</span>
                                </Col>
                                <Col xs={12} className={'user-dashboard-content-card__card-description'}>
                                    <span>0</span>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={6} lg={3} className={'user-dashboard-content-card'}>
                            <Row className={'user-dashboard-content-card__card-content'}>
                                <Col xs={12} className={'user-dashboard-content-card__card-header'}>
                                    <SvgIconComponent iconSource={IconStorage} className={'user-dashboard-content-card__card-header__header-icon'} />
                                    <span className={'user-dashboard-content-card__card-header__header-title'}>Storage Used</span>
                                </Col>
                                <Col xs={12} className={'user-dashboard-content-card__card-description'}>
                                    <span>0</span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>

                {/*<Col xs={12} className={`user-dashboard-content-section`}>*/}
                {/*    <Row className={`user-dashboard-content-section__section-container`}>*/}

                {/*        /!*<Col xs={12} className={`user-dashboard-content-section__section-header`}>*!/*/}
                {/*        /!*    <Row className={`user-dashboard-content-section__section-header__header-content`}>*!/*/}
                {/*        /!*        <Col xs={'auto'} className={`user-dashboard-content-section__section-header__header-content__header-text`}>*!/*/}
                {/*        /!*            <span>Your claims</span>*!/*/}
                {/*        /!*        </Col>*!/*/}
                {/*        /!*    </Row>*!/*/}
                {/*        /!*</Col>*!/*/}

                {/*        /!*<Col xs={12} className={'user-dashboard-content-section__section-content'}>*!/*/}
                {/*        /!*    <Row className={'user-dashboard-content-section__section-content__section-content'}>*!/*/}

                {/*        /!*    </Row>*!/*/}
                {/*        /!*</Col>*!/*/}

                {/*        /!*<Col xs={12} className={'user-dashboard-content-section__section-content'}>*!/*/}
                {/*        /!*    <Row className={'user-dashboard-content-section__section-content__section-content'}>*!/*/}
                {/*        /!*        <Col xs={12} className={'user-dashboard-user-claims-list'}>*!/*/}
                {/*        /!*            <Row className={'user-dashboard-user-claims-list__list-content'}>*!/*/}

                {/*        /!*            </Row>*!/*/}
                {/*        /!*        </Col>*!/*/}
                {/*        /!*    </Row>*!/*/}
                {/*        /!*</Col>*!/*/}

                {/*    </Row>*/}
                {/*</Col>*/}

                {/*<Col xs={12} className={`user-dashboard-content-section`}>*/}
                {/*    <Row className={`user-dashboard-content-section__section-container`}>*/}
                {/*        <Col xs={12} className={`user-dashboard-content-section__section-header`}>*/}
                {/*            <Row className={`user-dashboard-content-section__section-header__header-content`}>*/}
                {/*                <Col xs={'auto'} className={`user-dashboard-content-section__section-header__header-content__header-text`}>*/}
                {/*                    <span>Your claims</span>*/}
                {/*                </Col>*/}
                {/*            </Row>*/}
                {/*        </Col>*/}
                {/*    </Row>*/}
                {/*</Col>*/}

                {/*<Col xs={12} className={`user-dashboard-content-section`}>*/}
                {/*    <Row className={`user-dashboard-content-section__section-container`}>*/}

                {/*    </Row>*/}
                {/*</Col>*/}

            </Row>
        </Col>
    );

};


export default UserDashboardHomePageComponent;
